<template>
  <div class="row g-4">
    <div class="col-lg-4 col-12">
      <div class="form-field"><label class="field-label">تسمية القسم</label><InputText v-model="local.label" class="w-100" /></div>
    </div>
    <div class="col-lg-4 col-12">
      <div class="form-field"><label class="field-label">العنوان</label><InputText v-model="local.title" class="w-100" /></div>
    </div>
    <div class="col-lg-4 col-12">
      <div class="form-field"><label class="field-label">الوصف الفرعي</label><InputText v-model="local.subtitle" class="w-100" /></div>
    </div>
    <div class="col-12">
      <p class="field-hint">
        <i class="pi pi-info-circle"></i>
        العناصر المعروضة ({{ local.kind === 'course' ? 'الكورسات' : 'السنوات الدراسية' }}) تأتي تلقائياً من النظام ولا يمكن تعديلها من هنا.
      </p>
    </div>
  </div>
</template>

<script setup>
import { reactive, watch } from 'vue';
import InputText from 'primevue/inputtext';

const props = defineProps({ modelValue: { type: Object, default: () => ({}) } });
const emit = defineEmits(['update:modelValue']);

const local = reactive({
  kind: props.modelValue.kind ?? 'course',
  label: props.modelValue.label ?? '',
  title: props.modelValue.title ?? '',
  subtitle: props.modelValue.subtitle ?? '',
});

watch(local, () => emit('update:modelValue', { ...props.modelValue, ...local }), { deep: true });
</script>

<style scoped>
.field-hint { color: var(--text-sec, #6b7280); font-size: .85rem; display: flex; align-items: center; gap: .4rem; }
</style>
